import React from 'react';

const Li = ({ className = '', children }) => (
	<li className={`${className}`}>{children}</li>
);

const Ul = ({ className = '', children }) => (
	<ul className={`list-disc list-outside ${className}`}>{children}</ul>
);

export default {
	Li,
	Ul,
};
